var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row dashboard_stat"},[_c('balance'),_c('cash'),_c('card'),_c('less'),_c('total-today'),_c('total-month')],1)}
var staticRenderFns = []

export { render, staticRenderFns }